export default {
	init() {
		console.log('init hamburger');

		const hamburger = document.getElementsByClassName('navbar-toggler')[0];

		if (hamburger) {
			hamburger.addEventListener('click', e => {
				e.preventDefault();
				const target = hamburger.getAttribute('data-target');
				document.getElementById(target).classList.toggle('show');
			});
		}
	}
}
